<template>
  <div>
    <b-button variant="outline-primary" v-b-modal.webcam-1>Camera</b-button>
    <b-modal
      id="webcam-1"
      title="Capture Visitor Image"
      size="lg"
      @ok="handleOk"
    >
      <div style="display: flex; gap: 20px" class="flex-vertical">
        <div>
          <vue-web-cam
            ref="webcam"
            :device-id="deviceId"
            width="100%"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
          "
        >
          <b-form-select v-model="camera">
            <b-form-select-option :value="null"
              >Please select Device</b-form-select-option
            >
            <b-form-select-option
              v-for="device in devices"
              :key="device.deviceId"
              :value="device.deviceId"
              >{{ device.label }}</b-form-select-option
            >
          </b-form-select>

          <button type="button" class="btn btn-danger" @click="onStop">
            Close Camera
          </button>
          <button type="button" class="btn btn-success" @click="onStart">
            Open Camera
          </button>
          <button type="button" class="btn btn-primary" @click="onCapture">
            Capture Photo
          </button>
          <h2>Preview Image</h2>
          <figure class="figure">
            <img :src="img" class="img-responsive" width="200" />
          </figure>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { WebCam } from "vue-web-cam";

export default {
  components: {
    "vue-web-cam": WebCam,
  },
  props: {},
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
    };
  },
  computed: {
    device() {
      return find(this.devices, (n) => n.deviceId == this.deviceId);
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      let first = head(this.devices);
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
      console.log(this.img);
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
    
    handleOk(bvModalEvent) {
      // bvModalEvent.preventDefault();
      this.$emit('capimg',this.img)
      // let file = this.dataURLtoFile(this.img, "visitor");
      // const formData = new FormData();
      // formData.append("files", file);
      // formData.append("visitor", new Blob(["visitor"], { type: "text/plain" }));
      // console.log(formData,file);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .flex-vertical {
    flex-direction: column;
    align-items: center;
  }
}
</style>